import PosthogService from '~/services/posthog/PosthogService';
import { UserProfession } from '~/enums/UserProfession';

// Event-specific interface (co-located)
export interface IPermPostJobJobDescriptionSubmittedPayload {
  postingId: string;
  professionType: UserProfession;
}

/**
 * Fires when user submits job description in the post job flow
 * Event: dental_portal:perm_post_job:job_description_submitted
 */
export function firePermPostJobJobDescriptionSubmitted(
  payload: IPermPostJobJobDescriptionSubmittedPayload,
): void {
  PosthogService.getInstance().track('dental_portal:perm_post_job:job_description_submitted', {
    posting_id: payload.postingId,
    profession_type: payload.professionType,
  });
}